module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAA6klEQVQ4y83TsS5EQRjF8d9cg3gEhagQ7dfoeB8VvShEj8ZTLE+goZBopiRs6SHEWruaW9y9e+8WNE51kvPPN/OdzKSIGODVvHZxVPtLvHQwOxnPpZTTdhIRh/UQuCulXHcwZxmVbq3io+G7VFVIPWHq8TNMhWlPOO3xM0xG1q8Vi5VTRNzivu4i1actYQ8nNXiOJ3w3mAkOUkRsYgujxuRlvJdS3uq2t7GBr9bthrmxX3vPrg7mmBQRN3j45Qr7GcNSylW7nYg4rq8Nj6WUiw5mPWO8oOWRxRr/j4c06Qk/sdbwXZqkv37nH6x7SwcR8BHZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_ico4.png
// module id = 4qUI
// module chunks = 38